import * as React from 'react';

// Stable identifier used by the backend OtpStore to associate a sent OTP with
// its later verify call. In the GMaps flow this is the real `gmaps_place_id`;
// in the manual-entry flow we don't have one, so we synthesize a UUID v4 and
// persist it in localStorage so send and verify (and a page refresh in
// between) all see the same value.
const OTP_CORRELATION_KEY = 'rw_otp_correlation_id';

export const clearOtpCorrelationId = (): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(OTP_CORRELATION_KEY);
};

export const useOtpCorrelationId = (realGmapsPlaceId?: string | null): string => {
  return React.useMemo(() => {
    if (realGmapsPlaceId) return realGmapsPlaceId;
    if (typeof window === 'undefined') return '';
    let id = window.localStorage.getItem(OTP_CORRELATION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      window.localStorage.setItem(OTP_CORRELATION_KEY, id);
    }
    return id;
  }, [realGmapsPlaceId]);
};
